import React, { Component } from 'react';
import './../css/master.css';
import './../css/factory.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 
var httpURL = '';
var querystring = require('querystring');
var lstCity = [];
var lstFactory = [];
var flag = true;

var factoryIdCol 		= 'td:eq(0)';
var factoryCol 		    = 'td:eq(1)';
var factoryEmailCol 	= 'td:eq(2)';
var factoryPhoneCol 	= 'td:eq(3)';
var factoryAddCol     	= 'td:eq(4)';

class Factory extends Component {
  constructor(props) {
    super(props);
    this.state ={
      factory:[],
		  city:[],
		  width:'97.6%',
		  loader:'none',
		  opacity:1,
    }
    this.maintainFactory = this.maintainFactory.bind(this);
 }
	 
	componentDidMount =()=> {
	
		
		axiosInstance.get(httpURL+'/a/mst/fac/list', {
			withCredentials:true
		}).then((response) => {
			if(response.data.SvcStatus === 'Success'){	
				this.setState({
					factory: response.data.lstFactory,
				});
				lstFactory = this.state.factory;
				this.setFactoryTable();
			}else{
				toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e) => {
            toast.error('Service failed: '+e);
        });
       axiosInstance.get(httpURL+'/a/mst/cty/list',{
            withCredentials: true
        }).then((response)=> {
              if(response.data.SvcStatus === 'Success'){
                  this.setState({
                      city:response.data.lstCity,
                  })
                  lstCity = this.state.city;
                  this.fillCityCmb();
              }
              else{
                  toast.error(response.data.SvcMsg);
              }
              this.setState({loader:'none', opacity:1});
          }).catch((error)=> {
              toast.error("Service failed " + error);
        });

		this.handleResize();
		window.addEventListener("load", this.handleResize);
		window.addEventListener("resize", this.handleResize);
    }	
   getCityById=(pCityId)=>{
    for(var i=0; i<lstCity.length; i++){
        var cityId 	= lstCity[i].cityId;
        if(cityId==pCityId){
         return lstCity[i].city;
            
        }
        }
        return '';
   }
    fillCityCmb =()=>{
		$('#cityCmb').empty();
		$('#cityCmb').prepend($("<option> </option>").val(0).html('City'));
		for(var i=0; i<lstCity.length; i++){
			var cityId 	= lstCity[i].cityId;
			var city  	= lstCity[i].city;
			$('#cityCmb').append($("<option> </option>").val(cityId).html(city)); 
		}
  }
	handleResize=()=>{
		var width = ($('.tableLayout1').parent().width())-18;
		this.setState({width:width})
	}
	
	validateEmail(x){
		var atpos = x.indexOf("@");
		var dotpos = x.lastIndexOf(".");
		if (atpos<1 || dotpos<atpos+2 || dotpos+2>=x.length) {
			return false;
		}else{
			return true;
		}
	}
	
	setFactoryTable=()=>{
		$('#factoryTableBody tr').remove();
		var table = document.getElementById('factoryTable');
		var tbody = document.getElementById('factoryTableBody');
		var filterName = $("#factoryname").val().toLowerCase();
		var filterMail = $("#factoryemail").val().toLowerCase();
		var filterPhone = $("#factoryphone").val();
        var filterCity = $("#factorycity").val().toLowerCase();
        var filterContact = $("#contactPerson").val().toLowerCase();
		
		for(var i=0; i<lstFactory.length; i++){
			var factoryId	= lstFactory[i].factoryId;
			var factory 	= lstFactory[i].factoryName;
			var eMail		= lstFactory[i].emailId;
			var phoneNo	    = lstFactory[i].phoneNo;
			var cityId   	= lstFactory[i].cityId;
			var city		= lstFactory[i].city;
			var contact     =lstFactory[i].contactPerson;
			var row         = document.createElement('tr');
			row.onclick=(e)=>{
				flag = false;
				$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
				var factoryId = $(e.target).closest('tr').find(factoryIdCol).text();
				this.setFactoryForm(factoryId);
				
			}
			
			if(factory.toLowerCase().indexOf(filterName) == -1)
				continue;
			if(phoneNo.toString().indexOf(filterPhone) == -1)
				continue;
			if(eMail.toLowerCase().indexOf(filterMail) == -1)
				continue;
		
             if(contact.toLowerCase().indexOf(filterContact) == -1)
                continue;
                if(city.toLowerCase().indexOf(filterCity) == -1)
				continue;
			
			this.addTD(row, factoryId, 'no-display');
            this.addTD(row, factory, '');
            this.addTD(row, contact, '');
			this.addTD(row, eMail, '');
			this.addTD(row, phoneNo, '');
			this.addTD(row, city, '');
			
			tbody.append(row);
		}
		table.append(tbody);	
	}  
	
	addTD(row, val, classname){
		var cell = document.createElement('td');
		var text = document.createTextNode(val);
		cell.className = classname;
		cell.append(text);
		row.append(cell);
	}
	
	setFactoryForm=(id)=>{
		//$( "#email" ).attr( "disabled", true );
		var factoryData = this.getFactoryData(id);
		if(factoryData != -1){
            $('#name').val(factoryData.factoryName);
            $('#contactName').val(factoryData.contactPerson);
			$('#email').val(factoryData.emailId);
            $('#phone').val(factoryData.phoneNo);
            $('#address1').val(factoryData.address1);
            $('#address2').val(factoryData.address2);
			$('#cityCmb').val(factoryData.cityId);
		}
	}
	
	getFactoryData(id){
		for(var i=0; i<lstFactory.length; i++){
			if(lstFactory[i].factoryId == id){
			   return lstFactory[i];
			}
		}
		return -1;
	}
	

  maintainFactory =()=>{
	var factory	= {};
    var name	= $('#name').val();
    var contact	= $('#contactName').val();
	var email	= $('#email').val();
	var ph		= $('#phone').val();
    var address1	=$('#address1').val();
    var address2	=$('#address2').val();
    var cityId 		= $('#cityCmb').find('option:selected').val();
    var city 		= $('#cityCmb').find('option:selected').text();
	
	if(name == ''){
		toast.warning('Please fill Factory name');
		document.getElementById("name").focus();
		return false;
    }
    if(contact == ''){
		toast.warning('Please fill Contact Person Name');
		document.getElementById("phone").focus();
		return false;
    }




	if(email == ''){
		toast.warning('Please fill factory E-Mail');
		document.getElementById('email').focus();
		return false;
	}else{
		var result = this.validateEmail(email);
		if(result==false){
			toast.warning("Invalid Email");
			document.getElementById("email").focus();
			return false;
		}
    }
    if(ph == ''){
		toast.warning('Please fill staff phone number');
		document.getElementById("phone").focus();
		return false;
	}
    if(address1 == ''){
		toast.warning('Please fill Address');
		document.getElementById("address1").focus();
		return false;
    }
    if(cityId==0){
		toast.warning('Please select city');
		document.getElementById("cityCmb").focus();
		return false;
	}

	

	factory.factoryId = 0;
	factory.factoryName = name;
	factory.emailId = email;
	factory.phoneNo = ph;
	//staff.cityId = cityId;
    factory.address1 = address1;
    factory.address2 = address2;
    factory.cityId = cityId;
    factory.contactPerson = contact;
	if(flag === true){
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.post(httpURL+'/a/mst/fac/save',
			querystring.stringify({'factory':JSON.stringify(factory)}), {withCredentials:true}
    ).then((response)=>{
			if(response.data.SvcStatus === "Success"){
				toast.success(response.data.SvcMsg);
                factory.factoryId = response.data.factoryId;
                factory.city= this.getCityById(factory.cityId);
                lstFactory.push(factory);
                
				this.setFactoryTable();
				this.highlightRow('factoryTableBody', response.data.factoryId);
				this.setFactoryForm(response.data.factoryId);
				flag = false;
				$('#generatePassword').show();
			}
			else{
				toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});	 
		}).catch((e)=>{
			toast.error('Service failed: '+e);
		});
	}
	else{
		var factoryId = $('#factoryTableBody tr.selected').find('td:eq(0)').text();
		if(factoryId == ''){
			toast.warning('Please select row');
			document.getElementById("name").focus();
			return false;
		}

		if(email == ''){
			toast.warning('Please fill  E-Mail');
			document.getElementById('email').focus();
			return false;
		}else{
			var result = this.validateEmail(email);
			if(result == false){
				toast.warning("Invalid Email");
				document.getElementById("email").focus();
				return false;
			}
		}
	
		if(ph == ''){
			toast.warning('Please fill staff phone number');
			document.getElementById("phone").focus();
			return false;
		}
	
		if(address1 == 0){
			toast.warning('Please select city');
			document.getElementById("address").focus();
			return false;
		}
		 
        factory.factoryId = factoryId;
        factory.city= this.getCityById(factory.cityId);
		this.setState({loader:'block', opacity:0.5}); 
		axiosInstance.post(httpURL+'/a/mst/fac/save',
			querystring.stringify({'factory':JSON.stringify(factory)}), {withCredentials:true}
		).then((response)=>{
			if(response.data.SvcStatus == 'Success'){
				toast.success(response.data.SvcMsg);
				var factoryIdx = this.getIdxStaff(factoryId);
				lstFactory.splice(factoryIdx,1,factory);
				this.setFactoryTable();
				this.highlightRow('factoryTableBody', factoryId);
				this.setFactoryForm(factoryId);
			}else{
				toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1}); 
		}).catch((e)=>{
			toast.error('Service failed: '+e);
		});
	}
  }
	
  getIdxStaff(id){
	for(var i=0; i<lstFactory.length; i++){
		if(lstFactory[i].factoryId == id){
			return i;
		}
	}
	return -1;
 }
 
  clear=(e)=>{
		$("#factoryAddForm")[0].reset();
		//$('#email').attr('disabled', false);
		flag = true;
		$('#generatePassword').hide();
  }

  highlightRow(table, id){
	$('#'+table+' tr').each(function(){
		var factoryId = $(this).find('td:eq(0)').text();
		if(factoryId == id){
			$(this).addClass('selected').siblings().removeClass('selected');
		}
	});
  }  
  render() {
	httpURL = window.httpURL;  
	return(
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
            <div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div> 
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid">
					<div className="col-sm-11 col-centered">
						<div className="col-sm-7 col-xs-11 padding-remove">
							<table className="tableLayout1" style={{width:this.state.width}}>
								<thead>
									<tr>
									  <th style={{width:5, display:'none'}}>Factory Id</th>
										<th style={{width:100}}>
											<input type= "text"  onChange = {this.setFactoryTable} className= "form-control inp-search" id="factoryname"  placeholder= "Factory Name"/>
										</th>
                                        <th style={{width:100}}>
											<input type= "text"  onChange = {this.setFactoryTable} className= "form-control inp-search" id="contactPerson"  placeholder= "Contact Person"/>
										</th>
										<th style={{width:150}}>
											<input type= "text"  onChange = {this.setFactoryTable} className= "form-control inp-search" id="factoryemail" placeholder= "Email Id" />
										</th>
										<th style={{width:90}}>
											<input type= "text"  onChange = {this.setFactoryTable} className= "form-control inp-search" id="factoryphone" placeholder= "Phone No." />
										</th>
                    <th style={{width:90}}>
											<input type= "text"  onChange = {this.setFactoryTable} className= "form-control inp-search" id="factorycity"  placeholder= "Address" />
										</th>
									</tr>
								</thead>
                            </table>
							<div className="factoryTableDiv col-sm-12 col-xs-11 padding-remove">
								<table id="factoryTable" className="tableLayout">
									<colgroup>
										<col width='100' />
                                        <col width='100' />
										<col width='150' />
										<col width='90' />
										<col width='90' />
									</colgroup>
									<tbody id="factoryTableBody"></tbody>
								</table>
							</div>
                        </div>
						<div className="col-sm-1 col-xs-1">
							<span id="addStaff" title="Add Staff" onClick={this.clear} className="addIcon glyphicon glyphicon-plus-sign"></span>
						</div>
                        <div className="col-sm-4 col-xs-12">
							<form id="factoryAddForm" className="form-horizontal">
								<div className="form-group">
									<label className="control-label col-sm-5">Factory:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-7">
										<input type="text" className="form-control" placeholder="Factory Name" id="name"/>
									</div>
								</div>
                                <div className="form-group">
									<label className="control-label col-sm-5">Contact Person:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-7">
										<input type="text"  className="form-control" placeholder="Contact Name" id="contactName"/>
									</div>
								</div>
								<div className="form-group">
									<label className="control-label col-sm-5"> E-Mail:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-7">
										<input type="text" className="form-control" placeholder="E-Mail" id="email"/>
									</div>
								</div>
								<div className="form-group">
									<label className="control-label col-sm-5">Phone:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-7">
										<input type="text" maxLength="10" className="form-control" placeholder="Phone" id="phone"/>
									</div>
								</div>
								
								<div className="form-group">
									<label className="control-label col-sm-5">Factory Address:</label>
									<div className="col-sm-7">
										<input type="text" className="form-control" placeholder="Address 1" id="address1"/>
										<input type="text"  style={{marginTop:5, marginBottom:5}} className="form-control" placeholder="Address 2" id="address2"/>
										<select  style={{height:28, paddingVertical:4, width:'100%', borderRadius:4, borderColor:'#ccc', color:'gray'}} id="cityCmb" ></select>
									</div>
								</div>
								
							
								<div className="form-group" style={{marginTop:20}}>
								<div className="col-sm-12 text-center">
									<button type="button" onClick={this.maintainFactory} className="btn btn-warning">Save</button>
								
								</div>
								</div>
							</form>
						</div>
						
					</div>
				</div>
			</div>
        </div>
    )};
}

export default Factory;